// @ts-ignore
import * as React from "react";
import { Button, MiniModal } from "react-ui";

import { Icon } from "../Icons/Icon";

export function SessionExpiredModal(): JSX.Element {
    const onRefresh = () => {
        window.location.reload();
    };

    const onClose = () => {
        window.close();
    };

    return (
        <MiniModal disableClose>
            <MiniModal.Header icon={<Icon name="WarningCircleIcon" size={64} />}>
                Сессия приостановлена
            </MiniModal.Header>
            <MiniModal.Body>
                Сессия завершена из-за долгого ожидания или проблем с ее получением. Обновите страницу, чтобы продолжить
                работу
            </MiniModal.Body>
            <MiniModal.Footer direction="column">
                <Button use={"primary"} size={"medium"} onClick={onRefresh}>
                    Обновить страницу
                </Button>
                <Button size={"medium"} onClick={onClose}>
                    Закрыть редактор
                </Button>
            </MiniModal.Footer>
        </MiniModal>
    );
}
